import type { RenderableItem } from '@paintscout/util/builder'

/**
 * Whether ItemColumn should print each sub-item's price on its own row.
 *
 * A single sub-item's value is normally identical to the group total shown up top (next to the name,
 * where it's baseline-aligned), so repeating it on the sub-item row is pure duplication. That only holds
 * while the header actually shows a value, though: with "Show each area substrate as a row with price"
 * (`showDetailedBreakdown`) the builder blanks the area's own value, so hiding the lone sub-item's price
 * would leave the area with no price at all (#24103).
 */
export function shouldShowSubItemAmount(item: Pick<RenderableItem, 'value' | 'subItems'>): boolean {
  const subItemCount = item?.subItems?.length ?? 0
  return subItemCount !== 1 || !item.value
}
